import { SALE, RENT, PRECON } from 'Defaults'

export const intervalRent = [
  {
    'min': 0,
    'max': 1000,
    'stepSize': 1000,
    'sliderIntervalMin': 0,
    'sliderIntervalMax': 1,
  },
  {
    'min': 1000,
    'max': 2500,
    'stepSize': 50,
    'sliderIntervalMin': 1,
    'sliderIntervalMax': 31,
  },
  {
    'min': 2500,
    'max': 4000,
    'stepSize': 100,
    'sliderIntervalMin': 31,
    'sliderIntervalMax': 46,
  },
  {
    'min': 4000,
    'max': 6000,
    'stepSize': 500,
    'sliderIntervalMin': 46,
    'sliderIntervalMax': 50,
  },
]

export const intervalSale = [
  {
    'min': 0,
    'max': 300000,
    'stepSize': 50000,
    'sliderIntervalMin': 0,
    'sliderIntervalMax': 6,
  },
  {
    'min': 300000,
    'max': 900000,
    'stepSize': 10000,
    'sliderIntervalMin': 6,
    'sliderIntervalMax': 66,
  },
  {
    'min': 900000,
    'max': 1300000,
    'stepSize': 50000,
    'sliderIntervalMin': 66,
    'sliderIntervalMax': 74,
  },
  {
    'min': 1300000,
    'max': 5000000,
    'stepSize': 100000,
    'sliderIntervalMin': 74,
    'sliderIntervalMax': 111,
  },
]

export const bedroomOptions = [
  { value: '0.1-0.1', label: 'Studio' },
  { value: '1-1', label: '1' },
  { value: '1.1-1.9', label: '1 + Den' },
  { value: '2-2', label: '2' },
  { value: '2.1-2.9', label: '2 + Den' },
  { value: '3-99', label: '3+' },
]
export const saleRange = [0, 999999999]
export const rentRange = [0, 999999]

export const frequencyToStringMap = {
  2: 'Daily',
  1: 'Instant',
  3: 'Weekly',
  4: 'Monthly',
  0: 'Never',
}
export const frequencyOptions = [
  { value: '2', label: 'Daily' },
  { value: '1', label: 'Instant' },
  { value: '3', label: 'Weekly' },
  { value: '4', label: 'Monthly' },
  // { value: '0', label: 'Never' },
]

export const alertOfferOptions = [
  {
    label: 'For Sale',
    value: SALE,
  },
  {
    label: 'For Rent',
    value: RENT,
  },
  {
    label: 'Pre-Construction',
    value: PRECON,
  },
]

export const intervalSqft = [
  {
    'min': 0,
    'max': 300,
    'stepSize': 300,
    'sliderIntervalMin': 0,
    'sliderIntervalMax': 1,
  },
  {
    'min': 300,
    'max': 1000,
    'stepSize': 25,
    'sliderIntervalMin': 1,
    'sliderIntervalMax': 29,
  },
  {
    'min': 1000,
    'max': 4000,
    'stepSize': 100,
    'sliderIntervalMin': 29,
    'sliderIntervalMax': 59,
  },
  {
    'min': 4000,
    'max': 10000,
    'stepSize': 500,
    'sliderIntervalMin': 59,
    'sliderIntervalMax': 71,
  },
]
